<template>
  <div class="news">

    <div :class="[isMobile ? 'news-title-mobile' : 'news-title']">
      <label :class="[isMobile ? 'news-msg-mobile' : 'news-msg']">最新消息</label>
    </div>


    <div :class="[isMobile ? 'news-list-mobile' : 'news-list']" v-for="(item, index) of newsList" :key="index">

      <div   >
        <img class="news-img" :src="item.cover">

<!--        <el-image-->
<!--                :src="item.cover"-->
<!--                lazy-->
<!--                fit="fill"></el-image>-->
<!--&lt;!&ndash;                fit="scale-down"></el-image>&ndash;&gt;-->
      </div>

      <div class="news-item">
<!--        <label class="news-item-date">{{ item.guide }}</label>-->
          <label class="news-item-date">{{ item.guide }}</label>
          <label class="news-item-title" @click=choose(item)>{{ item.title }}</label>
<!--          <label class="detail-content-title">{{ detailDataItem.create_time }}</label>-->

        <div class="item-content-html" @click="choose(item)">{{ item.description }}</div>

        <div class="news-detail" @click=choose(item) v-if="!isMobile">詳細內容
          <img style="width:6px;height:10px" src="../assets/arrow_right.png">
        </div>

      </div>

    </div>


    <el-pagination :class="[isMobile ? 'news-bottom-page-mobile' : 'news-bottom-page']" @size-change="handleSizeChange"
      :small="isMobile" @current-change="handleCurrentChange" :current-page="queryInfo.page"
      :page-size="queryInfo.pagesize" :page-sizes="[1, 2, 5, 10]" background layout="prev, pager, next"
      :total="totalNum">
    </el-pagination>

  </div>


</template>


<script>

export default {
  name: 'News',
  data() {
    return {
      whichYear: "全部",
      newsList: [],
      totalNum: 0,
      queryInfo: {
        query: "",
        // 当前页数
        page: 1,
        // 显示一页多少条数据
        pagesize: 6,
      },
      isMobile: false
    }
  },
  created() {
    this.isMobile = window.isMobile
  },
  mounted() {
    this.fetchData()
  },

  methods: {
    getContent(content) {
      const div = document.createElement('div')
      div.innerHTML = content
      return div.innerText
    },
    fetchData() {
      var that = this;
      this.$axios.get("article/lists", { params: { cateId: "9", page: this.queryInfo.page, limit: this.queryInfo.pagesize } }).then(function (response) {
        //console.log('lists ' + JSON.stringify(response.data.data));
        that.newsList = response.data.data
        that.totalNum = response.data.count
      }, function (err) {
        console.log('errerrerrerrerr ' + err);
      });
    },
    handleCommand(command) {
      this.whichYear = command
    },
    choose(item) {
      //  this.$message('click on item ' + index);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      // //console.log('click on item ' + index);
      this.$router.push({ name: 'detail', params: { type: "news", data: item, } });
    },

    //每页的数据条数的需求，重新调用方法获取新的数据
    handleSizeChange(val) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val;
      this.fetchData();
    },
    //识别到页数的变化，自动获取新的数据
    handleCurrentChange(val) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      //console.log(`当前页: ${val}`);
      this.queryInfo.page = val;
      this.fetchData();
    }
  },
}
</script>

<style lang="scss" rel="stylesheet/scss">
.news {
  width: 100%;
  align-items: center;
  display: flex;
  background-size: cover;
  flex-direction: column;
  box-sizing: border-box;

  .news-title {
    margin-top: 30px;
    width: 1040px;
    display: flex;
    justify-content: space-between;

    .news-msg {
      font-size: 28px;
      color: #301E03
    }
  }

  .news-title-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .news-msg-mobile {
      font-size: 22px;
      color: #301E03
    }
  }

  .news-list {
    width: 1040px;
    display: flex;
    margin-top: 30px;

    .news-img {
      width: 310px;
      height: 200px;
      border-radius: 6px;
      margin-right: 29px;
      overflow: hidden;
        img{
            border-radius: 6px;
        }
    }

    .news-item {
      margin-right: 140px;
      flex: 1;
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .news-item-date {
        color: #A05200;
        font-size: 18px;
      }

      .news-item-title {
        margin-top: 18px;
        color: #301E03;
        font-size: 22px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item-content-html {
        color: #301E03;
        margin-top: 12px;
        font-size:16px;
        cursor: pointer;
        overflow: hidden;
        height: 67px;
        line-height: 22px;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:3;
        margin-bottom: 22px;
      }
    }



    .news-detail {
      cursor: pointer;
      width: 102px;
      height: 30px;
      background-color: #D9C8AD;
      font-size: 16px;
      border-radius: 3px;
      color: #A05200;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
    }
  }


  .news-list-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    display: flex;
    margin-top: 20px;

    .news-img {
      width: 100px;
      border-radius: 6px;
        /*overflow: hidden;*/
        /*img{*/
        /*    border-radius: 6px;*/
        /*}*/
    }

    .news-item {
      margin-left: 12px;
      flex: 1;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .news-item-date {
        color: #A05200;
        font-size: 14px;
      }

      .news-item-title {
        width: 100%;
        font-size: 14px;
        color: #301E03;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item-content-html {
        color: #53442E;
        font-size: 11px;
        width: 100%;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #D9C8AD;
    color: #fff;
  }

  .news-bottom-page {
    margin-top: 80px;
    margin-bottom: 88px;
  }

  .news-bottom-page-mobile {
    margin-top: 40px;
    margin-bottom: 40px;
  }

}
</style>
